import { AppContext } from '../../contexts/app-context';
import Footer from './footer';
import Gtm from './gtm';
import Header from './header';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import SharedHeader from '../../../hs-shared/components/header';
import SkipNav from '../common/skipNav';
import { getAlternativeProductDetails, updateBodyClass } from '../helper';
import React, { useEffect, useRef, useState } from 'react';
import '../../live-chat.css';

const Layout = ({ children, pageContext, page = '', notFound = '' }) => {
    const { currentMailCodesArray = null, currentProductData = null, currentMailCode = null, partnerData, partnerUrl, mainProducts, subPageType } = pageContext;

    const hasPageRendered = useRef({ propertyItem: false, excessItem: false });
    const mailCodesArray = currentMailCodesArray;
    const hasExcess = currentProductData?.excessAlternative === null ? false : true;
    const isPlanProduct = (currentProductData?.content.productElement?.includes('Plan')) ? true : false;
    const [mailCode, setMailcode] = useState(currentMailCode);
    const [productData, setProductData] = useState(currentProductData);
    const [isExcess, setExcess] = useState('high');
    const [propertyType, setPropertyType] = useState(productData?.fullName.includes('House') ? 'House' : productData?.fullName.includes('Flat') ? 'Flat' : 'both');

    const contextValues = {
        mailCode,
        productData,
        mailCodesArray,
        isExcess,
        hasExcess,
        propertyType,
        isPlanProduct,
        page,
        partnerData,
        partnerUrl,
        mainProducts,
        subPageType,
        setMailcode,
        setProductData,
        setExcess,
        setPropertyType
    };

    useEffect(() => {
        if (hasPageRendered.current.propertyItem) {
            if (typeof (document) !== 'undefined') {
                const propertyAlternatData = getAlternativeProductDetails(productData?.propertyAlternative?.mailcode, mailCodesArray);
                setMailcode(productData?.propertyAlternative?.mailcode);
                setProductData(propertyAlternatData);
                setTimeout(() => {
                    updateBodyClass(propertyType.toLowerCase());
                }, 50);
            }
        } else {
            if (typeof (document) !== 'undefined') {
                const type = new URLSearchParams(window.location.search);
                const propertyTypeQuery = type.get('propertyType');
                if (propertyTypeQuery !== null) {
                    setPropertyType(propertyTypeQuery);
                }
                setTimeout(() => {
                    updateBodyClass(propertyType.toLowerCase());
                }, 50);
            }
        }
        hasPageRendered.current.propertyItem = true;
    }, [propertyType]);

    useEffect(() => {
        if (typeof (document) !== 'undefined') {
            setTimeout(() => {
                updateBodyClass(propertyType.toLowerCase());
            }, 50);
        }
    }, [mailCode]);

    useEffect(() => {
        if (typeof (document) !== 'undefined' && page === 'product') {
            const type = new URLSearchParams(window.location.search);
            const excessTypeQuery = type.get('excess');
            if (hasPageRendered.current.excessItem) {
                if (excessTypeQuery !== null) {
                    const propertyAlternatData = getAlternativeProductDetails(productData?.excessAlternative?.mailcode, mailCodesArray);
                    setMailcode(productData?.excessAlternative?.mailcode);
                    setProductData(propertyAlternatData);
                } else {
                    setMailcode(productData?.mailcode);
                    setProductData(productData);
                }
            } else {
                if (excessTypeQuery !== null) {
                    setExcess(excessTypeQuery === 'low' ? 'low' : 'high');
                }
            }
        }
        hasPageRendered.current.excessItem = true;
    }, [isExcess]);

    // To show offers/shared header
    const showSharedHeader = (partnerData && partnerData.hasOwnProperty('shareStandardHeader')) ? partnerData.shareStandardHeader : true;
    const showSharedHeaderForPressPages = productData?.content?.dapPressHeroBanner === null || productData?.content?.dapPressHeroBanner === undefined;

    return (
        <AppContext.Provider value={contextValues}>
            <Gtm />
            <Helmet>
                <html itemScope itemType="https://schema.org/FAQPage" />
                <body className={`dap ${partnerData?.code?.toLowerCase()} ${propertyType?.toLowerCase()}`} />
                {
                    partnerData?.cssUrl && <link rel="stylesheet" href={`${process.env.MAIN_SITE_URL}${partnerData.cssUrl.replace(/~/g, '')}`} />
                }
            </Helmet>
            {
                (showSharedHeader && notFound === '') || !showSharedHeaderForPressPages ?
                    <SharedHeader /> :
                    <>
                        <SkipNav />
                        <Header notFound={notFound} />
                    </>
            }
            <div className="main-wrapper" id="main">
                {children}
            </div>
            <Footer />
        </AppContext.Provider>
    );
};

export default Layout;
Layout.propTypes = {
    children: PropTypes.node,
    pageContext: PropTypes.object,
    page: PropTypes.string,
    notFound: PropTypes.string
};
